import { render, staticRenderFns } from "./FavoriteCard.vue?vue&type=template&id=430c8832&scoped=true&lang=pug&"
import script from "./FavoriteCard.vue?vue&type=script&lang=js&"
export * from "./FavoriteCard.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteCard.vue?vue&type=style&index=0&id=430c8832&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430c8832",
  null
  
)

export default component.exports